import React from 'react';
import Color from 'color';
import { withTheme } from 'javascripts/theme';
import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';

type PillContentsProps = CardContentsComponent<'pill'> & {
  darkMode: boolean;
};

const PillContents: React.FC<PillContentsProps> = ({ pill, darkMode }) => {
  let background = pill.color;

  // We can only mix if we weren't passed a css variable
  if (typeof pill.color !== 'string' || !pill.color.startsWith('var')) {
    const bgColor = darkMode ? new Color('#21282e') : new Color('white');
    background = Color(pill.color).mix(bgColor, 0.6).hex();
  }

  return (
    <aha-pill
      color={background}
      text-color={pill.textColor}
      style={{ whiteSpace: 'nowrap' }}
    >
      {pill.icon ? (
        <>
          <i className={pill.icon.name} style={{ color: pill.icon.color }} />
          &nbsp;
        </>
      ) : null}
      {pill.text}
    </aha-pill>
  );
};

export default withTheme(PillContents);
